module.exports = __webpack_public_path__ + "static/3g_byj-208a15a51a6706dcd4bfd9e9c5cbf774.png";